export default __webpack_public_path__ + "static/mapstackmockup-dfc81794ada1f6e464879f195eede260.png";